import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Grid, Header } from 'semantic-ui-react';
import { Message } from 'components';
import { ExposureTable, ExposureChart } from '../../Analytics/components';
import { translateText } from '../../../../utils/helpers';

@connect((state) => ({
  french: state.Storage.language === 'fr',
}))
export default class Region extends Component {
  renderSubheader = (type) => {
    const { french } = this.props;
    return (
      <div className="sub header">
        {type === 'domicile'
          ? french
            ? 'Par région de domicile'
            : 'By Region of Domicile'
          : french
          ? 'Aux marchés boursiers régionaux'
          : 'To Regional Stock Markets'}
      </div>
    );
  };

  render() {
    const { analytics } = this.props;
    const { data } = analytics;
    const { french } = this.props;

    const assetData = {};
    const riskData = {};

    if (data.domicile && typeof data.domicile === 'object') {
      const tableLabels = [
        ...Object.keys(data.domicile),
        'Port. Specific Risk',
      ];
      tableLabels.forEach((label) => {
        assetData[label] = label in data.domicile ? data.domicile[label] : 0;
      });

      if (data.riskExp.C && typeof data.riskExp.C === 'object') {
        tableLabels.forEach((label) => {
          riskData[label] = label in data.riskExp.C ? data.riskExp.C[label] : 0;
        });
      }
    }

    return (
      <Container>
        <Header
          dividing
          size="large"
          content={
            french
              ? 'Analyse des avoirs et de l’exposition au risque'
              : 'Holdings and Risk Exposure Analysis'
          }
          subheader={french ? 'Par région' : 'By Region'}
        />

        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Header
                size="medium"
                content={
                  french ? 'Répartition des avoirs' : 'Holdings Breakdown'
                }
                subheader={this.renderSubheader('domicile')}
                style={{ margin: 0 }}
              />
              {typeof data.domicile === 'object' ? (
                <ExposureChart
                  title=""
                  labels={Object.keys(assetData)}
                  data={Object.values(assetData)}
                  frontierMarkets
                  hideLegend
                />
              ) : (
                <Message visible warning>
                  {translateText(data.domicile, french)}
                </Message>
              )}
            </Grid.Column>
            <Grid.Column>
              <Header
                size="medium"
                content={french ? 'Exposition au risque' : 'Risk Exposure'}
                subheader={this.renderSubheader('market')}
                style={{ margin: 0 }}
              />
              {typeof data.riskExp.C === 'object' ? (
                <ExposureChart
                  title=""
                  labels={Object.keys(riskData)}
                  data={Object.values(riskData)}
                  frontierMarkets
                  hideLegend
                />
              ) : (
                <Message visible warning>
                  {translateText(data.riskExp.C, french)}
                </Message>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {typeof data.riskExp.C === 'string' &&
        typeof data.domicile === 'string' ? null : (
          <ExposureTable
            headers={[
              french ? 'Région' : 'Region',
              <div>
                {french ? 'Répartition des titres' : 'Holdings Breakdown'}
              </div>,
              <div>{french ? 'Exposition au risque' : 'Risk Exposure'}</div>,
            ]}
            totals={[
              french ? 'Total' : 'Total',
              <div>100%</div>,
              <div>100%</div>,
            ]}
            data={[...Object.keys(data.domicile), 'Port. Specific Risk'].reduce(
              (total, key) => {
                total.push({
                  region: key === 'Other' ? 'Frontier Markets' : key,
                  holdingsBreakdown: data.domicile[key],
                  riskExposure: data.riskExp ? data.riskExp.C[key] : null,
                });

                return total;
              },
              []
            )}
            pdf
          />
        )}
      </Container>
    );
  }
}

Region.propTypes = {
  analytics: PropTypes.object,
  french: PropTypes.bool,
};

Region.defaultProps = {
  analytics: {},
  french: false,
};

const Container = styled.div`
  padding: 2rem 2rem 1rem 2rem;
`;
